import './form-job-grade.scss';
import { useFormContext } from "react-hook-form";
import { JobGradeFormSchema } from "@core/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";

type InputFormSchema = JobGradeFormSchema;
export function JobGrade() {
  const { control } = useFormContext<JobGradeFormSchema>();
  return (
    <div id="JobGrade" className="job-grade">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default JobGrade;